import React, {useState, useEffect} from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import { StarIcon } from "@heroicons/react/24/solid";
import { collection, getDocs} from "firebase/firestore";
import { database } from '../config/firebaseConfig';

import "swiper/css";
import "swiper/css/pagination";
import "../styles/customSwiperFeed.css";

function Feedback() {
    const WAIT_TIME = 1000; //Waits for 1s

    const stars = Array(5).fill(0);
    const [newData, setNewData] = useState(true);
    const [reviews, setReviews] = useState(null);
    
    /*
        Gets packages and tests
    */
    useEffect(() => {
        const interval = setInterval(() => { //Autorize re-render
            if (newData) {
                const reviewsRef = collection(database, "reviews");
                
                const getReviews = async() => {
                    const data = await getDocs(reviewsRef);
                    setReviews(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }

                console.log("Actualizo");
                getReviews();
                setNewData(false);
            }
        }, WAIT_TIME);
        return () => clearInterval(interval);
    }, [reviews, newData])

    return (
        <div className={`${reviews?.length? "block" : "hidden"} w-full h-card-web bg-white my-6`}>
          <div className={`px-4 py-6 flex flex-col w-full h-0 bg-white lg:py-8`}>
            <h2 className='lg:text-xl'>Comentarios del Servicio</h2>
            <span className='lg:w-80 w-48 border border-primary-100'></span>
          </div>
          
          <div className="w-full h-auto pt-10">
            <Swiper
                key={2}
                slidesPerView={3}
                spaceBetween={-100}
                centeredSlides={true}
                loop={true}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                modules={[Pagination, Autoplay]}
                className="SwiperFeed w-screen xl:w-1/2 h-[300px]"
            >
                {
                    reviews? reviews.map((review) => (
                        <SwiperSlide key={review.id} className="bg-primary-300 rounded-lg">
                
                            <div className="w-full flex flex-col items-center py-4 lg:py-1 space-y-2">
                                <img src="/images/userFeedback.svg" alt="" className="w-14 h-14 lg:w-20 lg:h-20" />
                                <div className="text-lg font-medium px-5">
                                    {review.userName}
                                </div>

                                <div className="text-xs font-light px-3 text-center h-12 overflow-y-auto">
                                    {review.description}
                                </div>

                                <div className='w-full flex flex-row space-x-1'>
                                    <div className='w-full flex flex-row justify-center'>
                                        {stars.map((_, index) => {
                                            return(
                                                <StarIcon key={index} className={`${(review.rating) > index ? "text-star" : "text-white"} h-1/2 w-auto max-h-14 max-w-14`}
                                                />
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))

                    :

                    <SwiperSlide key={0} className="bg-primary-300 rounded-lg">
                    
                        <div className="w-full flex flex-col items-center py-4 lg:py-1 space-y-2">
                            <img src="/images/userFeedback.svg" alt="" className="w-14 h-14 lg:w-20 lg:h-20" />
                            <div className="text-lg font-medium px-5">
                                Cargando...
                            </div>

                            <div className="text-xs font-light px-3 text-center h-12 overflow-y-auto">
                                Cargando...
                            </div>

                            <div className='w-full flex flex-row space-x-1'>
                                <div className='w-full flex flex-row justify-center'>
                                    {stars.map((_, index) => {
                                        return(
                                            <StarIcon key={index} className={`${(0) > index ? "text-star" : "text-white"} h-1/2 w-auto max-h-14 max-w-14`}
                                            />
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                }
            </Swiper>
          </div>
          
        </div>
    )
}

export default Feedback;

